import { Component, OnInit } from '@angular/core';
import {DropdownService} from "../services/dropdown.service";
import {IncidentService} from "../services/incident.service";
import {DataChangeRequestService} from "../services/DataChangeRequest.service";
import {ActivatedRoute} from "@angular/router";
import {IncidentRecord, IncidentSaveEditReq} from "../NIBINInterface";
import Swal from "sweetalert2";

@Component({
  selector: 'app-entry-requests',
  templateUrl: './entry-requests.component.html',
  styleUrls: ['./entry-requests.component.css'],
  providers: [DropdownService, DataChangeRequestService, IncidentService]
})
export class EntryRequestsComponent implements OnInit {
  hID: string | null | undefined;
  IncidentRecord: IncidentRecord | null | undefined;

  SharedEditToken: string = "";
  fullLabName: string = "";
  LabImg: string = "";
  ErrList:string[] = []

  showSavedMessage: boolean = false;
  showLockedMessage: boolean = false;


  constructor(private dropdownService: DropdownService, private dataChangeRequestService: DataChangeRequestService, private route: ActivatedRoute, private incidentService:IncidentService) {

  }

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
     this.hID = this.route.snapshot.queryParamMap.get('hID');
     this.loadRecord(this.hID);
  }

  async loadRecord(hID: string | null){
    this.dataChangeRequestService.getSharedEditToken(this.hID ?? '').then(async tok => {
      if(!tok){
        this.showLockedMessage = true;
        return;
      }
      this.SharedEditToken = tok ?? '';
      localStorage.setItem("SharedToken", tok ?? '')

      this.dataChangeRequestService.getSharedEditIncident(this.hID ?? '', this.SharedEditToken ?? '').then(inc => {
        if (inc) {
          this.IncidentRecord = this.incidentService.prepareEditIncident(inc)
          if (this.IncidentRecord.Lab) {
            this.dropdownService.getLabInfo(this.IncidentRecord?.Lab, this.SharedEditToken).then(lab => {
              this.LabImg = lab.LAB_IMAGE;
              this.fullLabName = lab.LAB_FN;
            });
          }
        }else {
          this.showLockedMessage = true;
        }
      }).catch(()=>{
        this.showLockedMessage = true;
      })
    }).catch(()=>{
      this.showLockedMessage = true;
    })
  }

  datesAreOnSameDay = (first:Date, second:Date) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();

  validateStep1(showError:boolean) : boolean{
    if(!this.IncidentRecord)
      return false;

    this.ErrList = [];
    if(!this.IncidentRecord.Inc_State || this.IncidentRecord.Inc_State =='' || this.IncidentRecord.Inc_State?.toLowerCase().includes('unknown')){
      this.ErrList.push("State is Required")
    }
    if(!this.IncidentRecord.County || this.IncidentRecord.County =='' || this.IncidentRecord.County?.toLowerCase().includes('unknown')) {
      this.ErrList.push("County is Required")
    }
    if(!this.IncidentRecord.Inc_City || this.IncidentRecord.Inc_City =='' || this.IncidentRecord.Inc_City?.toLowerCase().includes('unknown')) {
      this.ErrList.push("City is Required")
    }
    if(!this.IncidentRecord.Dept || this.IncidentRecord.Dept =='' || this.IncidentRecord.Dept?.toLowerCase().includes('unknown')) {
      this.ErrList.push("Agency is Required")
    }
    if(!this.IncidentRecord.LabNumber || this.IncidentRecord.LabNumber =='' || this.IncidentRecord.LabNumber?.toLowerCase().includes('unknown')) {
      this.ErrList.push("Lab # is Required")
    }
    if(!this.IncidentRecord.CaseNumber || this.IncidentRecord.CaseNumber =='' || this.IncidentRecord.CaseNumber?.toLowerCase().includes('unknown')) {
      this.ErrList.push("Case # is Required")
    }
    if(!this.IncidentRecord.OccurrenceDate || this.IncidentRecord.OccurrenceDate =='') {
      this.ErrList.push("Occurrence Date is Required")
    }
    if(!this.IncidentRecord.OccurrenceTime || this.IncidentRecord.OccurrenceTime =='') {
      this.ErrList.push("Occurrence Time is Required")
    }
    if(!this.IncidentRecord.Inc_Location || this.IncidentRecord.Inc_Location =='' || this.IncidentRecord.Inc_Location?.toLowerCase().includes('unknown')) {
      this.ErrList.push("Location is Required")
    }

    if(this.IncidentRecord.Weapon)
      for(const o of this.IncidentRecord.Weapon) {
        if (!o.CALIBER || o.CALIBER == '') {
          this.ErrList.push("WEAPON CALIBER is Required")
        }
        if (!o.W_CLASS || o.W_CLASS == ''  || o.W_CLASS?.toLowerCase().includes('unknown')) {
          this.ErrList.push("WEAPON CLASSIFICATION is Required")
        }
        if (!o.MAKE || o.MAKE == ''  || o.MAKE?.toLowerCase().includes('unknown')) {
          this.ErrList.push("WEAPON MANUFACTURE is Required")
        }
        if (!o.MODEL || o.MODEL == ''  || o.MODEL?.toLowerCase().includes('unknown')) {
          this.ErrList.push("WEAPON MODEL is Required")
        }
        if (!o.DTOFSUBMISSION || o.DTOFSUBMISSION == '') {
          this.ErrList.push("WEAPON DATE OF SUBMISSION is Required")
        }
        if (!o.DTOFCOLLECTION || o.DTOFCOLLECTION == '') {
          this.ErrList.push("WEAPON DATE OF COLLECTION is Required")
        }

        if(this.IncidentRecord.OccurrenceDate && o.DTOFCOLLECTION && o.DTOFSUBMISSION){
          if(!this.datesAreOnSameDay(new Date(this.IncidentRecord.OccurrenceDate),new Date(o.DTOFCOLLECTION))) {
            if(new Date(this.IncidentRecord.OccurrenceDate) > new Date(o.DTOFCOLLECTION))
              this.ErrList.push("WEAPON DATE OF COLLECTION MUST BE EQUAL OR GREATER THAN OCCURRENCE DATE")
          }
          if(!this.datesAreOnSameDay(new Date(o.DTOFSUBMISSION),new Date(o.DTOFCOLLECTION))) {
            if(new Date(o.DTOFCOLLECTION) > new Date(o.DTOFSUBMISSION))
              this.ErrList.push("WEAPON DATE OF SUBMISSION MUST BE EQUAL OR GREATER THAN COLLECTION DATE")
          }
        }

      }

    if(this.IncidentRecord.Ballistics)
      for(const o of this.IncidentRecord.Ballistics) {
        if (!o.Item_Quantity || o.Item_Quantity < 0) {
          this.ErrList.push("BALLISTIC Quantity is Required")
        }
        if (!o.DTOFSUBMISSION || o.DTOFSUBMISSION == '' ) {
          this.ErrList.push("BALLISTIC DATE OF SUBMISSION is Required")
        }
        if (!o.DTOFCOLLECTION || o.DTOFCOLLECTION == '') {
          this.ErrList.push("BALLISTIC DATE OF COLLECTION is Required")
        }

        if(this.IncidentRecord.OccurrenceDate && o.DTOFCOLLECTION && o.DTOFSUBMISSION){
          if(!this.datesAreOnSameDay(new Date(this.IncidentRecord.OccurrenceDate),new Date(o.DTOFCOLLECTION))) {
            if(new Date(this.IncidentRecord.OccurrenceDate) > new Date(o.DTOFCOLLECTION))
              this.ErrList.push("BALLISTIC DATE OF COLLECTION MUST BE EQUAL OR GREATER THAN OCCURRENCE DATE")
          }
          if(!this.datesAreOnSameDay(new Date(o.DTOFSUBMISSION),new Date(o.DTOFCOLLECTION))) {
            if(new Date(o.DTOFCOLLECTION) > new Date(o.DTOFSUBMISSION))
              this.ErrList.push("BALLISTIC DATE OF SUBMISSION MUST BE EQUAL OR GREATER THAN COLLECTION DATE")
          }
        }
      }

    if(this.IncidentRecord.Persons){
      for(const o of this.IncidentRecord.Persons) {
        if (!o.Role || o.Role == ''  || o.Role?.toLowerCase().includes('unknown')) {
          this.ErrList.push("PERSON ROLE is Required")
        }
        if (!o.FIRSTNAME || o.FIRSTNAME == ''  || o.FIRSTNAME?.toLowerCase().includes('unknown')) {
          this.ErrList.push("PERSON FIRSTNAME is Required")
        }
        if (!o.LASTNAME || o.LASTNAME == ''  || o.LASTNAME?.toLowerCase().includes('unknown')) {
          this.ErrList.push("PERSON LASTNAME is Required")
        }
      }

    }
    if(this.ErrList.length > 0){
      Swal.fire({
        icon: 'error',
        title: 'System Notification',
        text: 'Validation Error(s) Found. Please review the form and correct the errors listed.',
      })
    }
    return this.ErrList.length === 0;
  }

  processSaveReq($event: IncidentSaveEditReq) {
    if(!this.validateStep1(true))
      return;


    if(this.hID){
      Swal.fire({
        icon: 'info',
        title: 'System Notification',
        text: "Please wait while we save your changes",
      })

      this.dataChangeRequestService.saveSharedEditIncident(this.hID, $event, this.SharedEditToken).then(r => {
        Swal.fire({
          icon: 'success',
          title: 'System Notification',
          text: "Successfully Submitted Incident Record for Review",
          timerProgressBar: true,
          timer: 4000
        })

        this.showSavedMessage = true;
        this.IncidentRecord = null;
      })

    }
  }
}
